import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, TextSubHeading, IconFavorit, IconFavoritFill } from 'blocket-ui'
import styleguide from 'styleguide'
import { actionCreators as accountActionCreators } from 'reduxBits/account'
import { actionCreators as authActionCreators } from '@blocket/authentication-fe'
import { trackEvent } from '@blocket/tracking'
import { sharedButtonStyles, sharedButtonTextStyles } from '../FilterButton'

const StyledButton = styled(Button)`
  ${sharedButtonStyles}
`

const StyledButtonText = styled(TextSubHeading)`
  ${sharedButtonTextStyles}
  grid-row: 1;
  grid-column: 1/2;
`

const mapStateToProps = (state) => ({
  searchSaved: state.classified.searchResults.searchSaved,
  adwatchId: state.classified.searchResults.adwatchId,
  isCreating: state.account.adWatches.isCreating,
  isDeleting: state.account.adWatches.isDeleting,
  loggedIn: state.account.user.loggedIn,
  querySignature: state.classified.searchResults.querySignature,
})

const mapDispatchToProps = (dispatch) => ({
  accountActions: bindActionCreators(accountActionCreators, dispatch),
  authActions: bindActionCreators(authActionCreators.blocketLoginHelper, dispatch),
})

function HeartIcon({ filled }) {
  const size = 21

  if (filled) {
    return <IconFavoritFill color={styleguide.color.red} width={size} height={size} />
  }

  return <IconFavorit color="#363434" width={size} height={size} />
}

HeartIcon.propTypes = {
  filled: PropTypes.bool,
}

export const _CreateAdWatch = ({
  searchSaved,
  adwatchId,
  isCreating,
  isDeleting,
  loggedIn,
  querySignature,
  accountActions,
  authActions,
}) => (
  <StyledButton
    aria-label="Skapa bevakning"
    onClick={() => {
      if (!loggedIn) {
        trackEvent({
          eventType: 'Engagement',
          eventCategory: 'search',
          eventAction: 'watched search',
          eventLabel: 'log in prompt',
        })
        const callbackUrl = `/adwatch/create${window.location.search}`
        return authActions.setLoginToContinue({
          isOpen: true,
          cancelUri: `${window.location.pathname}${window.location.search}`,
          redirectUri: callbackUrl,
          message: 'När du loggar in kan du bevaka annonser.',
          tag: 'save_ad_watch',
        })
      }

      if (isCreating || isDeleting) {
        return null
      }

      if (searchSaved) {
        return accountActions.deleteAdWatch(adwatchId)
      }
      return accountActions.createAdWatch(querySignature)
    }}
  >
    <HeartIcon filled={searchSaved} />
    <StyledButtonText>{searchSaved ? 'Sparad bevakning' : 'Spara bevakning'}</StyledButtonText>
  </StyledButton>
)

_CreateAdWatch.propTypes = {
  accountActions: PropTypes.objectOf(PropTypes.func).isRequired,
  adwatchId: PropTypes.string,
  authActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isCreating: PropTypes.bool,
  isDeleting: PropTypes.bool,
  loggedIn: PropTypes.bool.isRequired,
  querySignature: PropTypes.string.isRequired,
  searchSaved: PropTypes.bool,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(_CreateAdWatch),
)
